import React from 'react';
import { Popover } from '@material-ui/core';

import { ClickableDiv } from '../../../components';
import { useIsMobile } from '../../../hooks';

import { depositOptions } from './MyPortalDepositOptionsPopup.constants';

import styles from './MyPortalDepositOptions.module.scss';

type Props = {
  isOpen: boolean;
  anchorEl: HTMLElement | null;
  handleSelect: (option: number) => void;
  handleClose: () => void;
}

const MyPortalDepositOptionsPopup = (props: Props) => {
  const { isOpen, anchorEl, handleSelect, handleClose } = props;
  const isMobile = useIsMobile();

  const onSelect = (option: number) => {
    handleSelect(option);
    handleClose();
  };

  return (
    <>
      { isMobile && isOpen ? (
        <div className={styles.wrapperMobile}>
          <ClickableDiv
            className={styles.wrapperMobileBackground}
            onClick={handleClose}
          />
          {/* TODO: Separate this part into a reusable component in HW-289 */}
          <div className={styles.wrapperOptions}>
            {depositOptions.map((deposit) => (
              <ClickableDiv
                key={deposit.id}
                className={styles.option}
                onClick={() => {
                  onSelect(deposit.id);
                }}
              >
                <div className={styles.optionIcon}>
                  <img src={deposit.icon} className={styles.icon} alt={deposit.title} />
                </div>
                <div className={styles.optionInfo}>
                  <div className={styles.optionTitle}>{deposit.title}</div>
                  <div className={styles.optionDescription}>{deposit.description}</div>
                </div>
              </ClickableDiv>
            ))}
          </div>
        </div>
      ) : (
        <Popover
          id={'dropdown-currency'}
          open={isOpen}
          anchorEl={anchorEl}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'left',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'left',
          }}
          onClose={handleClose}
          PaperProps={{
            style: {
              marginTop: '46px',
              marginLeft: '-20px',
              backgroundColor: '#1D3960',
              color: '#FDFFFF',
              border: '1px solid #3BB0FF',
              borderRadius: '2px',
              overflowY: 'hidden',
            },
          }}
        >
          <div>
            <div className={styles.wrapperOptions}>
              {depositOptions.map((deposit) => (
                <ClickableDiv
                  key={deposit.id}
                  className={styles.option}
                  onClick={() => {
                    onSelect(deposit.id);
                  }}
                >
                  <div className={styles.optionIcon}>
                    <img src={deposit.icon} className={styles.icon} alt={deposit.title} />
                  </div>
                  <div className={styles.optionInfo}>
                    <div className={styles.optionTitle}>{deposit.title}</div>
                    <div className={styles.optionDescription}>{deposit.description}</div>
                  </div>
                </ClickableDiv>
              ))}
            </div>
          </div>
        </Popover>
      )}
    </>
  );
};

export default MyPortalDepositOptionsPopup;
